import { createContext } from "react";

export const ExpensesContext = createContext([]);